import React from 'react'
import {
  Text,
  Select,
  TextInput,
  PasswordInput,
  Stack,
  useMantineTheme
} from '@mantine/core'
import { useLocalStorage } from '@mantine/hooks'

function Settings() {
  const theme = useMantineTheme()

  const [llmProvider, setLlmProvider] = useLocalStorage<string>({
    key: 'ai_llm_provider',
    defaultValue: 'Ollama Cloud',
  })

  const [apiKey, setApiKey] = useLocalStorage<string>({
    key: 'ai_api_key',
    defaultValue: '',
  })

  const [modelTag, setModelTag] = useLocalStorage<string>({
    key: 'ai_model_tag',
    defaultValue: '',
  })

  return (
    <div style={{ width: '100%' }}>
      <h1 style={{ fontWeight: 'bold', marginBottom: '32px', fontSize: '28px', color: theme.colorScheme === 'dark' ? theme.white : theme.black }}>
        Beállítások
      </h1>

      <div
        style={{
          display: 'flex',
          gap: '48px',
          flexDirection: 'row',
          alignItems: 'flex-start',
          flexWrap: 'wrap',
          justifyContent: 'space-between'
        }}
      >
        {/* Left Side: Title and Description */}
        <div style={{ flex: '1 1 300px', maxWidth: '350px' }}>
          <h2 style={{ margin: '0 0 8px 0', fontSize: '20px', fontWeight: 600, color: theme.colorScheme === 'dark' ? theme.white : theme.black }}>
            AI beállítások
          </h2>
          <Text size="sm" color="dimmed" style={{ lineHeight: 1.5 }}>
            Konfiguráld a szolgáltatót és a modellt a mesterséges intelligencia funkciók eléréséhez. A beállítások automatikusan mentésre kerülnek.
          </Text>
        </div>

        {/* Right Side: Configuration Inputs */}
        <div style={{ flex: '1 1 500px', maxWidth: '600px', width: '100%' }}>
          <Stack spacing="lg">
            <Select
              label="LLM szolgáltató"
              placeholder="Válassz szolgáltatót"
              data={['Ollama Cloud']}
              value={llmProvider}
              onChange={(val) => setLlmProvider(val || 'Ollama Cloud')}
              required
              styles={(theme) => ({
                label: {
                  fontWeight: 600,
                  color: theme.colorScheme === 'dark' ? theme.colors.dark[0] : theme.colors.gray[8],
                  marginBottom: 4,
                },
              })}
            />

            <PasswordInput
              label="API kulcs"
              placeholder="Írd be az API kulcsodat"
              value={apiKey}
              onChange={(event) => setApiKey(event.currentTarget.value)}
              description="Az Ollama Cloud eléréséhez szükséges API kulcs."
              styles={(theme) => ({
                label: {
                  fontWeight: 600,
                  color: theme.colorScheme === 'dark' ? theme.colors.dark[0] : theme.colors.gray[8],
                  marginBottom: 4,
                },
                description: {
                  marginTop: 4,
                }
              })}
            />

            <TextInput
              label="Modell tag"
              placeholder="pl. llama3, mistral, deepseek-coder"
              value={modelTag}
              onChange={(event) => setModelTag(event.currentTarget.value)}
              description="A használni kívánt modell azonosítója (tag)."
              styles={(theme) => ({
                label: {
                  fontWeight: 600,
                  color: theme.colorScheme === 'dark' ? theme.colors.dark[0] : theme.colors.gray[8],
                  marginBottom: 4,
                },
                description: {
                  marginTop: 4,
                }
              })}
            />
          </Stack>
        </div>
      </div>
    </div>
  )
}

export default Settings
